import React, { useState } from 'react';

import { SimplifiedStudy } from '../../types';
import styles from './MergeStudiesButton.module.scss';
import {
  Button,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Text,
} from 'components/core';
import { MergeStudiesDialog } from 'pages/StudyList/MergeStudiesDialog/MergeStudiesDialog';

type Props = {
  disabled?: boolean;
  studies?: SimplifiedStudy[];
  selectedStudyIds?: number[];
  reviewId?: string;
  onMergeSuccess?: () => void;
};

const noop = () => '';

export const MergeStudiesButton = (props: Props) => {
  const {
    disabled = false,
    studies = [],
    selectedStudyIds = [],
    reviewId = '',
    onMergeSuccess = noop,
  } = props;
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleClick = () => {
    setIsDialogOpen(true);
  };

  const handleClose = () => {
    setIsDialogOpen(false);
  };

  const handleSuccess = () => {
    onMergeSuccess();
  };

  const button = (
    <Button
      type={disabled ? 'neutral' : 'brand'}
      variant={disabled ? 'outline' : 'solid'}
      onClick={disabled ? noop : handleClick}
      data-pendo-key="merge-as-study"
    >
      Merge as study
    </Button>
  );

  if (!disabled) {
    return (
      <>
        {button}
        <MergeStudiesDialog
          isOpen={isDialogOpen}
          onClose={handleClose}
          reviewId={reviewId}
          studies={studies}
          selectedStudyIds={selectedStudyIds}
          onSuccess={handleSuccess}
        />
      </>
    );
  }

  return (
    <Popover strategy="fixed" closeOnEscape={true} forcePlacement>
      <PopoverTrigger>{button}</PopoverTrigger>
      <PopoverContent
        className={styles.popoverContent}
        aria-label="Merge as study"
      >
        <Text>Select two or more studies to merge</Text>
      </PopoverContent>
    </Popover>
  );
};
